export default __webpack_public_path__ + "static/media/search.e79ae1ef.svg";